
import React from 'react';
import propTypes from 'prop-types';
import TripMapView from '../../../../components/TripMapView';
import {connect} from 'react-redux';
import './style.css';

import * as navigator from '../../../../native/navigator';
import {sendStatsEvent} from '../../../../components/statistics';
import { isShare } from '../../from';
import { getPois } from '../../../../helpers/trip';
 
let renderLines = true;
let renderMarkers = true;


class MapView extends React.Component {
  static propTypes = {
    trip: propTypes.object.isRequired,
    day: propTypes.number.isRequired,
    route: propTypes.object
  };

  render() {
    let {trip, day, route} = this.props;

    return (
      <div className='map-view' onClick={this.onClick}>
        <TripMapView
          trip={trip}
          day={day}
          route={route}
          renderMarkers={renderMarkers}
          renderLines={renderLines}
          options={{
            dragging: false,
            touchZoom: false
          }} />
      </div>
    );
  }

  /**
   * 是否需要更新线路判断
   * 天数不同
   * 或者更新过trip
   * @param {*} nextProps 
   */
  componentWillReceiveProps(nextProps) {
    let {day, uTime, trip} = this.props;
    renderMarkers = (day !== nextProps.day) || (trip.update_time !== nextProps.trip.update_time);
    renderLines = uTime !== nextProps.uTime;
  }

  onClick = () => {
    let {trip, day} = this.props;
    sendStatsEvent('trip_smallmap_click');


    if(isShare()) return;
        
    navigator.push(`/m/v2/?m=render2&page=trip-map&trip_id=${trip.trip_id}&day=${day}`);
  };
}


export default connect(function (state, ownProps) {
  return {
    ...ownProps,
    uTime: state.route.route.uTime
  };
})(MapView);



// WEBPACK FOOTER //
// ./src/pages/trip/Trip/MapView/index.js